const GITLAB_PAGE_PATH = /\/-\/(?:blob|commit|raw|tree)(?:\/|$)/

function normalizeGitLabUrl(url, fallback) {
  // GitLab project pages put page-specific paths after "/-/":
  // /group/project/-/tree/main -> /group/project
  const projectPath = url.pathname.split('/-/')[0].replace(/\/+$/, '')
  const projectSegments = projectPath.split('/').filter(Boolean)

  return projectSegments.length >= 2
    ? `${url.origin}/${projectSegments.join('/')}`
    : fallback
}

/**
 * Return the cloneable repository root for known GitHub/GitLab page URLs and
 * recognizable GitLab page paths. All other values retain their current behavior.
 */
export function normalizeRepositoryUrl(value = '') {
  const input = value.trim()
  if (!input) return input

  try {
    const url = new URL(input)
    if (!['http:', 'https:'].includes(url.protocol)) return input

    if (url.hostname === 'github.com') {
      const [owner, repository] = url.pathname.split('/').filter(Boolean)
      return owner && repository
        ? `${url.origin}/${owner}/${repository}`
        : input
    }

    if (url.hostname === 'gitlab.com' || GITLAB_PAGE_PATH.test(url.pathname)) {
      return normalizeGitLabUrl(url, input)
    }

    return input
  } catch {
    // Includes the existing git@host:group/repository form.
    return input
  }
}
